import { render } from '../../assets/js/dom.js';

export const tag = 'reihe-requests';

export class ReiheRequests extends HTMLElement {
    static tag = tag;
    #handler = null;

    static {
        if (!customElements.get(ReiheRequests.tag)) {
            customElements.define(ReiheRequests.tag, ReiheRequests);
        }
    }

    constructor() {
        super();
        __webpack_public_path__ = `/reihe/resources/reihe-requests/`;
    }

    async connectedCallback() {
        const { context } = this.dataset;
        switch (context) {
            case "overlay":
                await this.overlayHandler();
                break;
            default:
                if ('navigation' in window) {
                    await this.navigationApiHandler();
                }
                break;
        }
    }

    async overlayHandler() {
        try {
            const { OverlayRequests } = await import('./overlay.js');
            this.#handler = new OverlayRequests(this);
            this.#handler.connect();
        } catch (error) {
            console.error(error);
        }
    }

    async navigationApiHandler() {
        try {
            const { NavigationRequests } = await import('./navigation-api.js');
            this.#handler = new NavigationRequests(this);
            this.#handler.connect();
        } catch (error) {
            console.error(error);
        }
    }

    #scrollToContainer(dialog) {
        const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        const behavior = prefersReducedMotion ? 'instant' : 'smooth';

        if (dialog) {
            const top = this.getBoundingClientRect().top + dialog.scrollTop - dialog.getBoundingClientRect().top;
            dialog.scrollTo({ top, behavior });
        } else {
            const header = document.querySelector('header-prime');
            const headerHeight = header?.getBoundingClientRect().height ?? 0;
            const top = this.getBoundingClientRect().top + window.scrollY - headerHeight;
            window.scrollTo({ top, behavior });
        }
    }

    #update(html, dialog) {
        // Prevents scroll container from clamping scrollTop to 0 while content is empty
        this.style.minHeight = `${this.offsetHeight}px`;
        this.replaceChildren();
        render(this, html);
        this.style.minHeight = '';
        this.#scrollToContainer(dialog);
    }

    async updateContent(url, dialog = null) {
        const headlessUrl = new URL(url, window.location.href);
        headlessUrl.searchParams.set('headless', 'true');
        const response = await fetch(headlessUrl.toString());
        if (!response.ok) { throw new Error(`HTTP ${response.status}`); }
        const html = await response.text();

        if ('startViewTransition' in document) {
            document.startViewTransition(() => this.#update(html, dialog));
        } else {
            this.#update(html, dialog);
        }
    }

    disconnectedCallback() {
        this.#handler?.cleanup();
        this.#handler = null;
    }
}
